<template>
  <div>
    <div class="ui secondary pointing top attached tabular menu three item">
      <a class="item active" v-on:click="getRPDs" data-tab="rpd_dep">Рабочие программы дисциплин</a>
      <a class="item" v-on:click="getRPPs" data-tab="rpp_dep">Рабочие программы практик</a>
<!--      <a class="item" v-on:click="getRPGs" data-tab="rpg_dep">Рабочие программы ГИА</a>-->
    </div>
    <div class="ui bottom attached tab segment active" data-tab="rpd_dep">
      <div class="ui styled fluid accordion">
        <div v-for="op in rpd">
          <div class="title">
            <tr>
              <td width="2%">
                <i class="dropdown icon"></i>
              </td>
              <td width="98%">
                <h3>{{op.name}}</h3>
              </td>
            </tr>
          </div>
          <div class="content">
            <div v-for="ep in op.arr">
              <div class="title">
                <tr>
                  <td width="2%">
                    <i class="dropdown icon"></i>
                  </td>
                  <td width="98%">
                    <h3>{{ep.name}}</h3>
                  </td>
                </tr>
              </div>
              <div class="content">
                <div v-for="prog in ep.arr">
                  <div class="title">
                    <tr>
                      <td width="1%">
                        <i class="dropdown icon"></i>
                      </td>
                      <td width="35%">
                        {{ prog.main_info.discipline }}
                      </td>
                      <td width="35%">
                        {{ prog.main_info.speciality }}
                      </td>
                      <td width="15%">
                        {{ prog.main_info.creator.fio }}
                      </td>
                      <td width="6%">
                        <a v-bind:href="'/programms/rpd/' + prog.id">Ссылка</a>
                      </td>
                    </tr>
                  </div>
                  <div class="content">
                    <div>
                      <button class="ui button blue" v-on:click="showRPD(prog.id)">
                        <i class="eye icon"></i>
                        Посмотреть
                      </button>
                      <button class="ui right floated button brown" v-on:click="getThemes(prog, 1)">
                        <i class="file pdf outline icon"></i>
                        Сформировать PDF
                      </button>
                      <button class="ui right floated button brown" v-on:click="MakeSupplementPDF(prog)">
                        <i class="file pdf outline icon"></i>
                        Сформировать лист дополнения
                      </button>
                      <button class="ui right floated button brown" v-on:click="getThemes(prog, 2)">
                        <i class="file pdf outline icon"></i>
                        Сформировать аннотацию
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpp_dep">
      <div class="ui styled fluid accordion">
        <div v-for="op in rpp">
          <div class="title">
            <tr>
              <td width="2%">
                <i class="dropdown icon"></i>
              </td>
              <td width="98%">
                <h3>{{op.name}}</h3>
              </td>
            </tr>
          </div>
          <div class="content">
            <div v-for="ep in op.arr">
              <div class="title">
                <tr>
                  <td width="2%">
                    <i class="dropdown icon"></i>
                  </td>
                  <td width="98%">
                    <h3>{{ep.name}}</h3>
                  </td>
                </tr>
              </div>
              <div class="content">
                <div v-for="prog in ep.arr">
                  <div class="title">
                    <tr>
                      <td width="1%">
                        <i class="dropdown icon"></i>
                      </td>
                      <td width="35%">
                        {{ prog.main_info.discipline }}
                      </td>
                      <td width="35%">
                        {{ prog.main_info.speciality }}
                      </td>
                      <td width="15%">
                        {{ prog.main_info.creator.fio }}
                      </td>
                      <td width="6%">
                        <a v-bind:href="'/programms/rpp/' + prog.id">Ссылка</a>
                      </td>
                    </tr>
                  </div>
                  <div class="content">
                    <div>
                      <button class="ui button blue" v-on:click="showRPP(prog.id)">
                        <i class="eye icon"></i>
                        Посмотреть
                      </button>
                      <button class="ui right floated button brown" v-on:click="MakeRPPPDF(prog)">
                        <i class="file pdf outline icon"></i>
                        Сформировать PDF
                      </button>
                      <button class="ui right floated button brown" v-on:click="MakeRPPSupplementPDF(prog)">
                        <i class="file pdf outline icon"></i>
                        Сформировать лист дополнения
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpg_dep">
      <div class="ui styled fluid accordion">
        <div v-for="op in rpg">
          <div class="title">
            <tr>
              <td width="2%">
                <i class="dropdown icon"></i>
              </td>
              <td width="98%">
                <h3>{{op.name}}</h3>
              </td>
            </tr>
          </div>
          <div class="content">
            <div v-for="ep in op.arr">
              <div class="title">
                <tr>
                  <td width="2%">
                    <i class="dropdown icon"></i>
                  </td>
                  <td width="98%">
                    <h3>{{ep.name}}</h3>
                  </td>
                </tr>
              </div>
              <div class="content">
                <div v-for="prog in ep.arr">
                  <div class="title">
                    <tr>
                      <td width="1%">
                        <i class="dropdown icon"></i>
                      </td>
                      <td width="35%">
                        {{ prog.name }}
                      </td>
                      <td width="35%">
                        {{ prog.main_info.speciality }}
                      </td>
                      <td width="15%">
                        {{ prog.main_info.creator.fio }}
                      </td>
                      <td width="8%">
                        {{ prog.main_info.year }}
                      </td>
                      <td width="6%">
                        <a v-bind:href="'/programms/rpg/' + prog.id">Ссылка</a>
                      </td>
                    </tr>
                  </div>
                  <div class="content">
                    <tr>
                      <td width="15%"><h4>Отправленно на согласование</h4></td>
                      <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                      <td width="25%">
                        <h4>
                          Отправлено {{prog.department_agreed_times}} раз
                        </h4>
                      </td>
                    </tr>
                    <div class="ui fitted divider"></div>
                    <div class="ui form">
                      <div class="inline fields">
                        <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] !== '05'">
                          <div class="ui right pointing large label">
                            Направление подготовки
                          </div>
                          <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                        </div>
                        <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] === '05'">
                          <div class="ui right pointing large label">
                            Специальность
                          </div>
                          <input type="text" placeholder="Специальность" v-model="prog.main_info.speciality" disabled="true">
                        </div>
                        <div class="four wide field">
                          <div class="ui right pointing large label">
                            Квалификация выпускника
                          </div>
                          <input type="text" placeholder="Квалификация" v-model="prog.main_info.quality" disabled="true">
                        </div>
                      </div>
                      <div class="inline fields">
                        <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] !== '05'">
                          <div class="ui right pointing large label">
                            Профиль
                          </div>
                          <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                        </div>
                        <div class="seven wide field" v-if="prog.main_info.speciality_code.split('.')[1] === '05'">
                          <div class="ui right pointing large label">
                            Специализация
                          </div>
                          <input type="text" placeholder="Профиль" v-model="prog.main_info.profile" disabled="true">
                        </div>
                        <div class="two wide field">
                          <div class="ui right pointing large label">
                            Год набора
                          </div>
                          <input type="text" placeholder="Год набора" v-model="prog.main_info.year" disabled="true">
                        </div>
                        <div class="three wide field">
                          <div class="ui right pointing large label">
                            Форма обучения
                          </div>
                          <input type="text" placeholder="Форма обучения" v-model="prog.main_info.edu_form" disabled="true">
                        </div>
                      </div>
                      <div class="ui equal width form">
                        <div class="inline fields">
                          <div class="four wide field">
                            <div class="ui right pointing large label">
                              И.О.Фамилия
                            </div>
                            <input type="text" placeholder="И.О.Фамилия" v-model="prog.main_info.creator.fio" disabled="true">
                          </div>
                          <div class="four wide field">
                            <div class="ui right pointing large label">
                              Должность
                            </div>
                            <input type="text" placeholder="Должность" v-model="prog.main_info.creator.position" disabled="true">
                          </div>
                          <div class="four wide field">
                            <div class="ui right pointing large label">
                              Ученая степень
                            </div>
                            <input type="text" placeholder="Ученая степень" v-model="prog.main_info.creator.title" disabled="true">
                          </div>
                        </div>
                      </div>
                      <div class="two fields">
                        <div class="six wide field">
                          <label>Выпускающая кафедра</label>
                          <div class="ui input">
                            <input type="text" placeholder="Выпускающая кафедра" v-model="prog.main_info.grad_dep" disabled="true">
                          </div>
                        </div>
                        <div class="six wide field">
                          <label>Заведующий выпускающей кафедры</label>
                          <div class="ui input">
                            <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="prog.main_info.provisor" disabled="true">
                          </div>
                        </div>
                      </div>
                      <div class="three fields">
                        <div class="five wide field">
                          <label>Факультет</label>
                          <div class="ui input">
                            <input type="text" placeholder="Факультет" v-model="prog.main_info.facility" disabled="true">
                          </div>
                        </div>
                        <div class="five wide field">
                          <label>Обеспечивающая кафедра</label>
                          <div class="ui input">
                            <input type="text" placeholder="Обеспечивающая кафедра" v-model="prog.main_info.department" disabled="true">
                          </div>
                        </div>
                        <div class="five wide field">
                          <label>
                            Заведующий кафедрой
                          </label>
                          <div class="ui input">
                            <input type="text" placeholder="Заведующий кафедрой" v-model="prog.main_info.dep_manager" disabled="true">
                          </div>
                        </div>
                      </div>
                      <div class="two fields">
                        <div class="four wide field">
                          <label>Дата заседания кафедры</label>
                          <div class="ui input">
                            <input type="text" placeholder="Дата заседания кафедры" v-model="prog.main_info.approval_date" disabled="true">
                          </div>
                        </div>
                        <div class="two wide field">
                          <label>Протокол №</label>
                          <div class="ui input">
                            <input type="text" placeholder="Протокол №" v-model="prog.main_info.protocol_num" disabled="true">
                          </div>
                        </div>
                      </div>
                      <div><textarea rows="2" v-model="prog.main_info.basis" disabled="true"></textarea></div>
                      <div class="two fields">
                        <div class="four wide field">
                          <label>Дата утверждения приказа</label>
                          <div class="ui input">
                            <input type="text" placeholder="Дата утверждения приказа" v-model="prog.main_info.basis_date" disabled="true">
                          </div>
                        </div>
                        <div class="two wide field">
                          <label>№ Приказа</label>
                          <div class="ui input">
                            <input type="text" placeholder="№ Приказа" v-model="prog.main_info.basis_num" disabled="true">
                          </div>
                        </div>
                      </div>
                      <h3 class="ui dividing header">1 ОБЩИЕ ПОЛОЖЕНИЯ</h3>
                      <div>
                        <h4>1.2 Виды деятельности выпускников и соответствующие им типы задач профессиональной деятельности:</h4>
                        <h5>1.2.1 Виды деятельности выпускников</h5>
                        <span v-html="prog.active_type.actives"></span>
                        <h5>1.2.2 Типы задач профессиональной деятельности</h5>
                        <span v-html="prog.active_type.tasks"></span>
                        <h5>1.2.3. Требования к профессиональной подготовленности выпускника, необходимые для выполнения им задач профессиональной деятельности</h5>
                        <div>
                          <div class="ui form"><textarea rows="2" type="text" placeholder="Преамбула к компетенциям" v-model="prog.preamble_comp" disabled="true"></textarea></div>
                          <h4>а) Универсальные компетенции выпускников и индикаторы их достижения</h4>
                          <table class="ui basic celled table">
                            <thead>
                            <tr class="active">
                              <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
                              <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
                              <th width="40%"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "comp in prog.competition.UK">
                              <td>{{comp.info.cat}}</td>
                              <td>
                                {{ comp.info.code }} {{ comp.info.desc }}
                              </td>
                              <td v-html="comp.text"></td>
                            </tr>
                            </tbody>
                          </table>
                          <h4>б) Общепрофессиональные компетенции выпускников и индикаторы их достижения</h4>
                          <table class="ui basic celled table" v-if="prog.competition.OPK_cat.length">
                            <thead>
                            <tr class="active">
                              <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
                              <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                              <th width="40%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "comp in prog.competition.OPK_cat">
                              <td>{{comp.info.cat}}</td>
                              <td>
                                {{ comp.info.code }} {{ comp.info.desc }}
                              </td>
                              <td v-html="comp.text"></td>
                            </tr>
                            </tbody>
                          </table>
                          <table class="ui basic celled table" v-if="prog.competition.OPK.length">
                            <thead>
                            <tr class="active">
                              <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                              <th width="60%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "comp in prog.competition.OPK">
                              <td>{{comp.name}}</td>
                              <td v-html="comp.text"></td>
                            </tr>
                            </tbody>
                          </table>
                          <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
                          <table class="ui basic celled table">
                            <thead>
                            <tr class="active">
                              <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
                              <th width="60%"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "comp in prog.competition.PK">
                              <td>{{comp.name}}</td>
                              <td v-html="comp.text"></td>
                            </tr>
                            </tbody>
                          </table>
                          <h4>г) Дополнительные профессиональные компетенции выпускников и индикаторы их достижения</h4>
                          <table class="ui basic celled table">
                            <thead>
                            <tr class="active">
                              <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
                              <th width="60%"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "comp in prog.competition.DPK">
                              <td>{{comp.name}}</td>
                              <td v-html="comp.text"></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <h3 class="ui dividing header">2 ТРЕБОВАНИЯ К ВЫПУСКНОЙ КВАЛИФИКАЦИОННОЙ РАБОТЕ</h3>
                      <h4>2.2. Структура выпускной квалификационной работы и требования к ее содержанию</h4>
                      <span v-html="prog.structure_old"></span>
                      <h4>2.3 Примерная тематика и порядок утверждения тем выпускных квалификационных работ</h4>
                      <span v-html="prog.subject_old"></span>
                      <h4>2.4 Учебно-методическое и информационное обеспечение</h4>
                      <div>
                        <h5>2.4.1 Рекомендуемая литература</h5>
                        <span v-html="prog.literature_old"></span>
                        <h5>2.4.2 Программное обеспечение и Интернет-ресурсы</h5>
                        <h5>Программное обеспечение</h5>
                        <table class="ui basic celled table">
                          <thead>
                          <tr class="active">
                            <th width="20%"><div class="headTable">Наименование</div></th>
                            <th width="40%"><div class="headTable">Описание</div></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for = "soft in prog.software">
                            <td>
                              {{soft.info.name}}
                            </td>
                            <td>
                              {{ soft.info.license }}
                            </td>
                          </tr>
                          <tr v-for = "res in prog.resources">
                            <td>{{res.name}}</td>
                            <td>{{res.desc}}</td>
                          </tr>
                          </tbody>
                        </table>
                        <h4>2.4.3 Профессиональные базы данных и информационные справочные системы</h4>
                        <table class="ui basic celled table">
                          <thead>
                          <tr class="active">
                            <th width="20%"><div class="headTable">Наименование</div></th>
                            <th width="40%"><div class="headTable">Описание</div></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for = "db in prog.data_bases">
                            <td>{{db.name}}</td>
                            <td>{{db.desc}}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <h4>2.5 Порядок выполнения и представления в ГЭК выпускной квалификационной работы</h4>
                      <span v-html="prog.order_execution_old"></span>
                      <h4>2.6 Порядок защиты выпускной квалификационной работы</h4>
                      <span v-html="prog.order_def_old"></span>
                      <h4>2.7 Критерии выставления оценок (соответствия уровня подготовки выпускника требованиям ФГОС ВО) на основе выполнения и защиты им квалификационной работы </h4>
                      <span v-html="prog.criteria_old"></span>
                      <div v-if="prog.main_info.speciality_code === '40.03.01' || prog.main_info.speciality_code === '41.03.01' || prog.main_info.speciality_code === '41.04.01' || prog.main_info.speciality_code === '46.03.01'">
                        <h3 class="ui dividing header">3 ТРЕБОВАНИЯ К ВЫПУСКНИКУ, ПРОВЕРЯЕМЫЕ В ХОДЕ ГОСУДРАСТВЕННОГО ЭКЗАМЕНА</h3>
                        <h4>3.1 Перечень основных учебных модулей – дисциплин образовательной программы или их разделов и вопросов, выносимых для проверки на государственном экзамене</h4>
                        <table class="ui basic celled table">
                          <thead>
                          <tr class="active">
                            <th>Дисциплина (раздел дисциплины)</th>
                            <th>Перечень вопросов</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for = "work in prog.discipline">
                            <td width="30%">{{ work.name }}</td>
                            <td width="68%" v-html="work.content"></td>
                          </tr>
                          </tbody>
                        </table>
                        <h4>3.2 Список рекомендуемой литературы</h4>
                        <span v-html="prog.literature_gos_old"></span>
                        <h4>3.3 Критерии выставления оценок на государственном экзамене</h4>
                        <span v-html="prog.criteria_gos_old"></span>
                        <h4>3.4 Порядок проведения экзамена</h4>
                        <span v-html="prog.order_examination_old"></span>
                      </div>
                      <div class="ui fitted divider"></div>
                      <div>
                        <button class="ui button negative" v-on:click="denyRPG(prog.id, ep.arr.indexOf(prog), op.arr.indexOf(ep), rpg.indexOf(op), prog.department_agreed_times, prog.department_comment)">
                          Отклонить
                        </button>
                        <button class="ui right floated button positive" v-on:click="agreedRPG(prog.id, ep.arr.indexOf(prog), op.arr.indexOf(ep), rpg.indexOf(op))">
                          Согласовать
                        </button>
                        <button class="ui right floated button blue" v-on:click="showRPG(prog.id)">
                          Просмотр
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import htmlToText from "html-to-text";
import competitionsMixin from "../mixins/competitionsMixin";
import computedMixin from "../mixins/computedMixin";
import dataRpdMixin from "../mixins/dataRpdMixin";
import _ from 'lodash';
import moment from "moment/moment";
import rpd_pdf from "../../../../makepdfs/programms/rpd_pdf";
import rpd_anotation_pdf from "../../../../makepdfs/programms/rpd_anotation_pdf";
import rpd_supplement_pdf from "../../../../makepdfs/programms/rpd_supplement_pdf";
import rpp_supplement_pdf from "../../../../makepdfs/programms/rpp_supplement_pdf";
import rpp_pdf from "../../../../makepdfs/programms/rpp_pdf";
import rpd_spo_pdf from "../../../../makepdfs/programms/rpd_spo_pdf";

export default {
  name: "department_agreed",
  mixins: [competitionsMixin, computedMixin, dataRpdMixin],
  data: () => ({
    rpd: [],
    rpp: [],
    rpg: [],
    prog_rpd: {},
    prog_rpp: {}
  }),
  methods: {
    getRPDs() {
      axios({
        method: 'get',
        url: `/programms/rpd_report`
      }).then((response) => {
        this.rpd = response.data
      }).catch((error) => {
        return error;
      });
    },
    showRPD(id){
      location.assign(`/programms/rpd/${id}`)
    },
    getThemes(prog, param){
      axios({
        method: 'get',
        url: `/programms/get_themes/${prog.id}`,
      }).then((response) => {
        this.themes = response.data.themes;
        if (param === 1){
          this.sortThemes()
          axios({
            method: 'get',
            url: `/programms/get_rpd/${prog.id}`,
          }).then((response) => {
            this.prog_rpd = response.data.rpd;
            if (prog.main_info.speciality_code.split('.')[1] === '02'){
              rpd_spo_pdf.MakePDF(this.prog_rpd, this.spo_control, this.spo_times, this.o_lectureTime, this.o_practiceTime, this.o_laboratoryTime, this.o_ikrTime,
                  this.o_ktoTime, this.o_keTime, this.o_lessonTime, this.o_seminarTime, this.o_controlTime, this.o_indepTime, this.o_lectures, this.o_lesson,
                  this.o_seminar, this.o_practice, this.o_laboratory, this.o_indepWork, this.o_themes)
            }
            else {
              rpd_pdf.MakePDF(this.prog_rpd, this.o_lectureTime, this.o_practiceTime, this.o_laboratoryTime, this.o_ikrTime,
                  this.o_ktoTime, this.o_keTime, this.o_lessonTime, this.o_seminarTime, this.o_controlTime, this.o_indepTime, this.o_lectures, this.o_lesson,
                  this.o_seminar, this.o_practice, this.o_laboratory, this.o_indepWork, this.z_control, this.z_times, this.z_lectureTime, this.z_practiceTime,
                  this.z_laboratoryTime, this.z_ikrTime, this.z_ktoTime, this.z_keTime, this.z_controlTime, this.z_indepTime, this.z_indepWork, this.o_themes, this.z_themes)
            }
            }).catch((error) => {
            return error;
          });
        }
        else if(param === 2){
          axios({
            method: 'get',
            url: `/programms/get_rpd/${prog.id}`,
          }).then((response) => {
            this.prog_rpd = response.data.rpd;
            rpd_anotation_pdf.MakePDF(this.prog_rpd, this.o_themes)
          }).catch((error) => {
            return error;
          });
        }
      }).catch((error) => {
        return error;
      });
    },
    sortThemes(){
      this.themes.sort(function(a, b) {
        return a.num - b.num;
      });
    },
    MakeSupplementPDF(prog) {
      axios({
        method: 'get',
        url: `/programms/get_rpd/${prog.id}`,
      }).then((response) => {
        this.prog_rpd = response.data.rpd;
        rpd_supplement_pdf.MakePDF(this.prog_rpd)
      }).catch((error) => {
        return error;
      });
    },
    getRPPs() {
      axios({
        method: 'get',
        url: `/programms/rpp_report`
      }).then((response) => {
        this.rpp = response.data
      }).catch((error) => {
        return error;
      });
    },
    showRPP(id){
      location.assign(`/programms/rpp/${id}`)
    },
    MakeRPPSupplementPDF(prog) {
      axios({
        method: 'get',
        url: `/programms/get_rpp/${prog.id}`,
      }).then((response) => {
        this.prog_rpp = response.data.rpp;
        rpp_supplement_pdf.MakePDF(this.prog_rpp)
      }).catch((error) => {
        return error;
      });
    },
    MakeRPPPDF(prog) {
      axios({
        method: 'get',
        url: `/programms/get_rpp/${prog.id}`,
      }).then((response) => {
        this.prog_rpp = response.data.rpp;
        rpp_pdf.MakePDF(this.prog_rpp)
      }).catch((error) => {
        return error;
      });
    },
    getRPGs() {
      axios({
        method: 'get',
        url: `/programms/department_agreed_rpg`
      }).then((response) => {
        this.rpg = response.data
      }).catch((error) => {
        return error;
      });
    },
  },
  mounted() {

  }
}
</script>